export class CriterePondere {

	public critere: string;
	public criterePCT: number;

	constructor() {
		this.critere = '';
		this.criterePCT = 0;
	}
}
